export default "/pin-placeholder.8f3a9bd1-c0abd4.jpg";